import React from 'react';

function Logo() {
    return (
        <span className="display-inline-block overflow-x-hidden">
            <img
                height="auto"
                width="110px"
                src="https://www.kbb.com/cm-api/content/static/img/partner/kbb/KBB_Logo_Rev_White_RGB_Small.svg"
                alt="Kelley Blue Book logo"
            />
        </span>
    );
}
export default Logo;
